export default "__VITE_ASSET__DdhDFH5m__"